var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRekamedis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3408 2.6037C11.7333 2.46543 12.1661 2.46543 12.5687 2.6037L19.2014 4.82867C19.9462 5.07382 20.4495 5.76122 20.4495 6.52608L20.4999 13.1637C20.5099 15.174 19.7751 17.1253 18.4264 18.6561C17.8125 19.3621 17.0174 19.9603 16.0109 20.4996L12.4379 22.4117C12.3272 22.4706 12.2064 22.5 12.0856 22.5C11.9648 22.5 11.834 22.4706 11.7233 22.4117L8.12005 20.5486C7.1035 20.0191 6.30838 19.4307 5.68436 18.7345C4.31554 17.2244 3.55062 15.273 3.54055 13.2628L3.50014 6.62316C3.49023 5.8583 3.99347 5.17286 4.7282 4.91693L11.3408 2.6037Z",
    fill: "#0A805D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 2,
    height: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13,
    width: 2,
    height: 6,
    transform: "rotate(-90 9 13)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRekamedis);
export default __webpack_public_path__ + "static/media/rekamedis.37d37a2dfd3642e8a35c50f3dec4574b.svg";
export { ForwardRef as ReactComponent };